<template>
  <div class="results">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="card">
        <p class="title">Check-Ins</p>
        <div class="action_btns">
          <div class="filter">
            <div
              class="inputs survey-forms"
              v-if="allLocations && allLocations.length"
            >
              <sub>Filter by Location</sub>
              <div class="input full">
                <v-select
                  :options="allLocations"
                  label="name"
                  :reduce="(l) => l.id"
                  :clearable="false"
                  v-model="filter_values.location"
                  @input="
                    () => {
                      (this.filteredAmount = 0), moveToPage(0);
                    }
                  "
                >
                  <template v-slot:option="option">
                    <div>
                      {{
                        `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                      }}
                    </div>
                  </template>
                </v-select>
              </div>
            </div>
            <div
              class="inputs survey-forms"
              v-if="allDepartments && allDepartments.length"
            >
              <sub>Filter by Department</sub>
              <div class="input full">
                <v-select
                  :options="allDepartments"
                  label="name"
                  :reduce="(d) => d.id"
                  :clearable="false"
                  v-model="filter_values.department"
                  @input="
                    () => {
                      (this.filteredAmount = 0), moveToPage(0);
                    }
                  "
                ></v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              Show Checked In Employees?
              <input
                type="checkbox"
                v-model="checkInFilter"
                @change="handleCheckInFilter"
              />
            </div>
            <div class="inputs survey-forms">
              <button
                v-if="showClearBtn"
                @click="clearFilter"
                class="btn round-btn red"
              >
                Clear Filter
              </button>
            </div>
          </div>
          <!-- <div class="filters">
            <button @click="inputFileToExport" class="btn round-btn">
              Export
            </button>
          </div>-->
        </div>
        <div class="table-holder">
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Department</th>
                <th>Location</th>
                <th>Checked In</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(user, id) in users">
                <tr :key="id" :class="{ grey: id % 2 }">
                  <td data-label="First Name">
                    {{ user.first_name }}
                    <template v-if="user.init_reminders">
                      <span class="has-reminder">Has Reminder</span>
                    </template>
                  </td>
                  <td data-label="Last Name">{{ user.last_name }}</td>
                  <td data-label="Email">
                    {{ user.email ? user.email : "N/A" }}
                  </td>
                  <td data-label="Phone Number">
                    {{ user.phone ? user.phone : "N/A" }}
                  </td>
                  <td data-label="Department" :key="id">
                    {{
                      user.department && departments[user.department]
                        ? departments[user.department].name
                        : "TBD"
                    }}
                  </td>
                  <td data-label="Location">
                    {{
                      user.location && locations[user.location]
                        ? locations[user.location].name
                        : "No location set"
                    }}
                  </td>
                  <td data-label="Checked In">
                    <p v-if="handleCheckIn(user.last_checked_in)">
                      <img
                        class="action clickable"
                        style="cursor: default"
                        src="@/assets/img/check.svg"
                      />
                      @{{ user.last_checked_in | format_date_time }}
                    </p>
                    <p v-else>
                      <img class="dash" src="@/assets/img/pending.svg" />
                      <!-- <span>Haven't Checked In Today</span> -->
                    </p>
                  </td>

                  <!-- <td data-label="Send">
                    <img
                      @click="selectUser(user)"
                      class="action clickable"
                      src="@/assets/img/send.svg"
                    />
                  </td>-->
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <p>
            {{ calcPaginationPageTotal }}
            <span>of</span>
            {{ calcUserAmount }} - Pg: {{ pagination.current_page }}
          </p>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(-1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>

          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Switches from "vue-switches";
import moment from "moment";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  props: ["source"],
  components: {
    Switches,
  },
  data() {
    return {
      individualSend: true,
      send_email: false,
      send_text: false,
      forms: null,
      helper: false,
      showPopup: false,
      popupType: "email",
      form: null,
      selected_user: null,
      visitors: [],
      employees: [],
      usage: {
        forms: 0,
        visitors: 0,
        employees: 0,
        locations: 0,
        departments: 0,
        managers: 0,
      },
      department_names: {},
      delivery_types: [],
      unfilteredUsers: [],
      filter_values: {},
      checkInFilter: false,
      loading: false,
      selected_dates: [],
      visibleUsers: [],
      reoccurrence_type: null,
      showClearBtn: false,
      showBulkBtn: false,
      checkedIn: false,
      selected_location: null,
      selected_department: null,
      selected_users: [],
      allLocations: [],
      usage: [],
      users: [],
      allDepartments: [],
      sendText: functions.httpsCallable("sendText"),
      sendEmail: functions.httpsCallable("sendSurveyLinkEmail"),
      getEmailLink: functions.httpsCallable("getEmailLink"),
      importCSV: functions.httpsCallable("importCSV"),
      exportCSV: functions.httpsCallable("exportCSV"),
      importLoading: false,
      isFiltered: false,
      filteredAmount: 0,
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
    };
  },
  firestore() {
    return {
      usage: db.collection("usage").doc(this.user_doc.id),
      allLocations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations"),
      allDepartments: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("departments"),
    };
  },
  computed: {
    calcUserAmount() {
      let total = 0;
      if (this.filteredAmount && this.isFiltered) {
        total = this.filteredAmount;
      } else if (!this.isFiltered && !this.filteredAmount) {
        total = this.usage["employees"];
      }
      return total;
    },
    calcPaginationPageTotal() {
      let total =
        this.pagination.current_page +
        this.pagination.page_size * this.pagination.current_page -
        this.pagination.current_page;

      if (total > this.usage["employees"]) {
        if (this.filteredAmount && this.isFiltered) {
          total = this.filteredAmount;
        } else if (!this.isFiltered && !this.filteredAmount) {
          total = this.usage["employees"];
        }
      }
      return total;
    },
    locations() {
      let locationMap = {};
      this.allLocations.forEach((l) => {
        locationMap[l.id] = l;
      });
      return locationMap;
    },
    departments() {
      let departmentMap = {};
      this.allDepartments.forEach((l) => {
        departmentMap[l.id] = l;
      });
      return departmentMap;
    },
    button_valid() {
      this.delivery_types = [];
      if (this.send_email) this.delivery_types.push("email");
      if (this.send_text) this.delivery_types.push("phone");
      if (this.delivery_types.length) {
        return {};
      } else {
        return { opacity: "30%", "pointer-events": "none" };
      }
    },
  },
  created() {
    return this.moveToPage(0);
  },
  methods: {
    handleCheckInFilter(e) {
      if (e.target.checked) {
        this.checkedIn = true;
      } else {
        this.checkedIn = false;
      }
      this.moveToPage(0);
    },
    handleCheckIn(date) {
      if (!date) return false;
      let today = moment().startOf("day").valueOf();
      let last_checked_in = moment(date).startOf("day").valueOf();
      return today == last_checked_in;
    },

    async moveToPage(page) {
      let pagination = this.pagination;

      if (this.checkedIn) {
        let ref = db
          .collection("user")
          .doc(this.user_doc.id)
          .collection("employee")
          .where(`last_checked_in`, "<=", Date.now())
          .orderBy("last_checked_in", "desc");

        for (const key in this.filter_values) {
          if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
            const element = this.filter_values[key];
            if (element) {
              ref = ref.where(`${key}`, "==", element);
            }
          }
          this.isFiltered = true;
        }

        if (this.isFiltered && !this.filteredAmount) {
          let filteredAmount = await ref.get();
          this.filteredAmount = filteredAmount.size;
        }

        if (page === -1) {
          //Previous Page
          ref = ref
            .limit(pagination.page_size)
            .startAfter(pagination.previous_doc);
        } else if (page === 1) {
          //Next Page
          ref = ref.limit(pagination.page_size).startAfter(pagination.next_doc);
        } else if (page === 0) {
          //First page
          ref = ref.limit(pagination.page_size);
        } else {
          //Last page
          let total;
          if (this.filteredAmount && this.isFiltered) {
            total = this.filteredAmount;
          } else if (!this.isFiltered && !this.filteredAmount) {
            total = this.usage["employees"];
          }
          let last_full_page = Math.floor(total / pagination.page_size);
          let limit = total - last_full_page * pagination.page_size;
          ref = ref.limit(limit || pagination.page_size);
        }

        let query = await ref.get();
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let users = docs.map((d) => Object.assign({ id: d.id }, d.data()));
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total
            if (this.filteredAmount && this.isFiltered) {
              total = this.filteredAmount;
            } else if (!this.isFiltered && !this.filteredAmount) {
              total = this.usage["employees"];
            }
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.users = users;
        }
        this.pagination = Object.assign({}, this.pagination);
        return true;
      } else {
        let ref = db
          .collection("user")
          .doc(this.user_doc.id)
          .collection("employee");
        for (const key in this.filter_values) {
          if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
            const element = this.filter_values[key];
            if (element) {
              ref = ref.where(`${key}`, "==", element);
            }
          }
          this.isFiltered = true;
        }

        if (this.isFiltered && !this.filteredAmount) {
          let filteredAmount = await ref.get();
          this.filteredAmount = filteredAmount.size;
        }
        if (page === -1) {
          //Previous Page
          ref = ref
            .limit(pagination.page_size)
            .orderBy("last_name", "desc")
            .startAfter(pagination.previous_doc);
        } else if (page === 1) {
          //Next Page
          ref = ref
            .limit(pagination.page_size)
            .orderBy("last_name")
            .startAfter(pagination.next_doc);
        } else if (page === 0) {
          //First page
          ref = ref.limit(pagination.page_size).orderBy("last_name");
        } else {
          //Last page
          let total
            if (this.filteredAmount && this.isFiltered) {
              total = this.filteredAmount;
            } else if (!this.isFiltered && !this.filteredAmount) {
              total = this.usage["employees"];
            }
          let last_full_page = Math.floor(total / pagination.page_size);
          let limit = total - last_full_page * pagination.page_size;
          ref = ref
            .limit(limit || pagination.page_size)
            .orderBy("last_name", "desc");
        }

        let query = await ref.get();
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let users = docs.map((d) => Object.assign({ id: d.id }, d.data()));
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total
            if (this.filteredAmount && this.isFiltered) {
              total = this.filteredAmount;
            } else if (!this.isFiltered && !this.filteredAmount) {
              total = this.usage["employees"];
            }
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.users = users;
        }
        this.pagination = Object.assign({}, this.pagination);
        return true;
      }
    },

    clearFilter() {
      this.showBulkBtn = false;
      this.filteredAmount = 0;
      this.filter_values = {};
      this.isFiltered = false;
      this.moveToPage(0);
    },
  },
  watch: {
    // users() {
    //   return this.moveToPage(0);
    // },

    filter_values: {
      handler(val) {
        if (Object.keys(val).length) {
          this.showClearBtn = true;
        }
        this.filteredAmount = 0;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
  .img-btn {
    font-size: 13px;
    text-decoration: none;
    display: flex;
    align-items: center;
    @media screen and (max-width: 600px) {
      margin-top: 10px;
    }
    img {
      height: 16px;
      filter: brightness(0) invert(1);
      margin-right: 10px;
    }
  }
}

.full .v-select {
  max-width: 100%;
}

.holder .btn {
  margin-top: 20px;
}

.full {
  width: 100%;
}

.loader {
  height: 100px;
}

.btn-helper {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
  .text_btn {
    padding: 0;
  }
  .helper {
    position: absolute;
    top: 15px;
    width: 100%;
    z-index: 99;
    background-color: white;
    box-shadow: 0 0 8px rgba(128, 128, 128, 0.35);
    p {
      font-size: 15px;
    }
  }
}

.mult-action {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #eaeaea;
  background: #3bbf6f;
  position: fixed;
  z-index: 99999;
  width: 100%;
  left: 0;
  bottom: 0;
  justify-content: center;
  p {
    width: 100%;
    text-align: center;
    color: #ffffff;
    margin: 0;
    font-weight: bold;
    span {
      display: block;
      font-size: 15px;
      opacity: 0.7;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }
  label {
    color: white;
  }
}

.has-reminder {
  display: block;
  font-size: 13px;
  color: #3bbf6f;
  padding: 3px;
  margin-top: 5px;
  border-radius: 10px;
  text-align: center;
  font-weight: bold;
  background: rgba(59, 191, 111, 0.1);
}

.dash {
  font-size: 11px;
  font-weight: bold;
  opacity: 0.4;
  height: 23px;
  padding-right: 10px;
}
</style>
